import { useState, useEffect } from "react";
import { getTranscriberConfigs, SaveTranscriberConfigs, UpdateTranscriberConfigs, DeleteTranscriberConfigs } from './../../utils/APIClient'
import { useForm } from "react-hook-form";
import { triggerAlert, ConfirmationAlert } from './../../utils/commonFunctions'
import Modal from 'react-bootstrap/Modal';
import { createThemeData, customStyles } from './../../utils/Constants'
import DataTable, { createTheme } from "react-data-table-component";
const TranscriberConfigs = () => {
    document.title = "Callingo | Transcriber Configuration"
    const { register, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm();
    const [folderList, setfolderList] = useState([])
    const [hide, sethide] = useState(false)
    const [editid, seteditid] = useState()

    const [loading, setLoading] = useState(false);
     const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Sr.No",
            selector: (row, i) => i,
            cell: (row, i) => i + 1,
        },
        {
            name: "Transcriber Provider",
            selector: (row) => row.transcriber_provider,
            cell: row => row.transcriber_provider,
        },
        {
            name: "Transcriber Model",
            selector: (row) => row.transcriber_model,
            cell: row => row.transcriber_model,
        },
        
        {
            name: "Language",
            selector: (row) => row.language,
            cell: row => row.language,
        },
        
        {
            name: "Action",

            cell: row => (
                <div className="col-auto" id="tooltip-container9">
                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => { sethide(true); onloadeddata(row) }}  >
                        <i className="ri-edit-box-line  "></i>   </button>
                    <button className="btn btn-link text-danger btn-lg p-0" onClick={() => { ConfirmationAlert("Do you want to delete Transcriber Configurations from database", "Delete", () => DeleteFolder(row)); }}>
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
        },

    ]
    const getFolderLists = async () => {
        setLoading(true);
        try {
            let folders = await getTranscriberConfigs();
            if (folders.data) {
                setLoading(false);
                if (folders.data) {
                    setfolderList([...folders.data])
                }
            }
        } catch (error) {
            setLoading(false);
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    const submitFolder = async (data) => {
        if (editid) {
            data.folder_id = editid
            try {
                const response = await UpdateTranscriberConfigs(data);
                const respdata = response.data;
                if (response.status === 200) {
                    triggerAlert('success', '', `Transcriber Configuration updated successfully` || 'Something went wrong');
                    getFolderLists();
                    sethide(false)
                }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        } else {
            try {
                const response = await SaveTranscriberConfigs(data);
                const respdata = response.data;
                if (response.status === 201) {
                    triggerAlert('success', '', `Transcriber Configuration created successfully` || 'Something went wrong');
                    getFolderLists();
                    sethide(false)
                }
            } catch (error) {
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }

    }
    const onloadeddata = (data) => {
        setValue("transcriber_provider", data.transcriber_provider)
        setValue("transcriber_model", data.transcriber_model)
        setValue("language", data.language)
        seteditid(data.id)
    }
    const DeleteFolder = async (data) => {
        try {
            const response = await DeleteTranscriberConfigs(data.id);
            const respdata = response.data;
            if (response.status === 204) {
                triggerAlert('success', '', `Transcriber Configuration deleted successfully` || 'Something went wrong');
                getFolderLists();
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    const handlePageChange = page => {
        getFolderLists(page_size, page )
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getFolderLists(newPerPage, page )
        setpage_size(newPerPage);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    useEffect(() => {
        getFolderLists();
    }, [])
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">Transcriber Configuration</h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="page-title-box mb-3">
                    <button className="btn btn-success  mt-0 page-title-right" onClick={() => { sethide(true); reset(); seteditid("") }} ><i className=" ri-user-add-line"></i> Create Transcriber Configuration</button>
                    <div className="page-title-left">
                        <div className="app-search">
                            <form>
                                <div className="mb-2 position-relative">
                                    <input type="text" className="form-control border border-dark border-opacity-10" placeholder="Search files..." />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card  ">
                        <div className="card-body">

                            {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                                <DataTable
                                    columns={columns}
                                    fixedHeader

                                    persistTableHead
                                    data={folderList}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalPages}
                                    paginationDefaultPage={page_number}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    paginationPerPage={page_size}
                                     
                                    theme="solarized"
                                    paginationComponentOptions={paginationComponentOptions}
                                    customStyles={customStyles}
                                />}

                           
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={hide} onHide={() => sethide(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Transcriber Configuration</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(submitFolder)}>
                    <Modal.Body>
                        <div className="mb-3">
                            <label htmlFor="transcriber_provider" className="form-label">Transcriber Provider</label>
                            <input
                                type="text"

                                id="transcriber_provider"
                                name="transcriber_provider"
                                {...register("transcriber_provider", { required: "Transcriber Provider is required" })}
                                className="form-control"
                                placeholder="Enter your Transcriber Provider"
                                autoComplete='off'
                            />
                            {errors.transcriber_provider && <small className="text-danger d-block mb-2">{errors.transcriber_provider.message}</small>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="transcriber_model" className="form-label">Transcriber Provider</label>
                            <input
                                type="text"

                                id="transcriber_model"
                                name="transcriber_model"
                                {...register("transcriber_model", { required: "Transcriber Model is required" })}
                                className="form-control"
                                placeholder="Enter your Transcriber Model"
                                autoComplete='off'
                            />
                            {errors.transcriber_model && <small className="text-danger d-block mb-2">{errors.transcriber_model.message}</small>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="language" className="form-label">language</label>
                            <input
                                type="text"

                                id="language"
                                name="language"
                                {...register("language", { required: "language is required" })}
                                className="form-control"
                                placeholder="Enter your language"
                                autoComplete='off'
                            />
                            {errors.language && <small className="text-danger d-block mb-2">{errors.language.message}</small>}
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-warning  rounded px-3" onClick={() => sethide(false)}>Cancel</button>
                        <button type="submit" className="btn btn-success  rounded px-3">Save</button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>

    )
}

export default TranscriberConfigs;